import {useLocation, useNavigate} from 'react-router'
import {authService} from '~/initializers/auth'
import {Input} from '@eitje/web_components'
import {PageLayout, Layout, Title, FormSubmitButton} from '~/components'
import {NewForm} from '@eitje/form'
import {validateEmail} from '~/helpers'

export const Login = () => {
	const navigate = useNavigate()
	const {state} = useLocation()

	const handleLogin = async ({email, password}) => {
		const {token} = await authService.login(email, password)
		if (token) {
			navigate('/', {replace: true}) // replace login page with home page, ensures a valid page in history. Also allows correct behaviour of goBack on direct url navigation to modals.
			if (state?.path) {
				navigate(state.path)
			}
		}
	}

	return (
		<PageLayout gap={8}>
			<Layout margin="25vh 0 0 0">
				<NewForm onSubmit={handleLogin} variant="box" gap={20}>
					<Title t="auth.welcome" />

					<Layout direction="vertical" width={340} gap={8}>
						<Input field="email" required validate={validateEmail} />
						<Input field="password" secure required />
					</Layout>
					<FormSubmitButton iconLeft={false} t="auth.login" />
				</NewForm>
			</Layout>
		</PageLayout>
	)
}
